import AbstractRepository from './AbstractRepository';
import collect from 'collect.js';

interface PoloFilters {
    servico_id?: number,
}

export default class PoloRepository extends AbstractRepository {
    static resource = 'polo';

    /**
     * Resgata lista de pólos disponíveis
     * 
     * @param filters Filtros para API
     * 
     * @return Collection<unknown>
     */
    public static async listar(filters: PoloFilters = {}) {
        let response = await this.get(`${this.resource}`, filters);
        let lista = collect(response.dados);
        return lista;
    }
}